import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { heroSlides } from '../data/mock';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <section className="relative h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ backgroundColor: slide.bgColor }}
        >
          <div className="pp-container h-full">
            <div className="flex items-center justify-between h-full">
              {/* Text Content - Right Side */}
              <div className="flex-1 text-right space-y-6">
                <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
                  {slide.title}
                </h1>
                <p className="text-xl md:text-2xl text-gray-600 max-w-xl mr-auto">
                  {slide.subtitle}
                </p>
                <div>
                  <Button 
                    size="lg" 
                    className="bg-[#005bbb] hover:bg-[#004a99] text-white px-8 py-6 text-lg"
                  >
                    {slide.cta}
                  </Button>
                </div>
              </div>

              {/* Image Placeholder - Left Side */}
              <div className="hidden lg:block flex-1">
                <div className="relative">
                  <div className="w-96 h-96 mx-auto">
                    <div className="w-full h-full bg-white rounded-lg shadow-xl flex items-center justify-center border border-gray-200">
                      <div className="text-center">
                        <div className="w-48 h-48 mx-auto bg-gradient-to-br from-[#005bbb] to-[#0077dd] rounded-full opacity-10"></div>
                        <p className="mt-4 text-gray-400">محصول صنعتی</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Navigation Buttons */}
      <button
        onClick={prevSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-lg transition-all z-10"
      >
        <ChevronRight className="w-6 h-6 text-gray-700" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-lg transition-all z-10"
      >
        <ChevronLeft className="w-6 h-6 text-gray-700" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex space-x-2 space-x-reverse z-10">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              index === currentSlide
                ? 'bg-[#005bbb] w-8'
                : 'bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;